import { createRoot } from 'react-dom/client';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import 'reflect-metadata';

import App from './App';
import reportWebVitals from './reportWebVitals';

const rootContainer = document.getElementById('root');

const root = createRoot(rootContainer!);
root.render(
  <StyledEngineProvider injectFirst>
    <CssBaseline />
    <App />
  </StyledEngineProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
